import { OrderHistoryReducerState } from "@store/Store/Reducers/OrderHistoryProductSelectorReducer";

export const getOrderHistoryProductSelector = (state: OrderHistoryReducerState) => state.orderHistoryReducer;
